import { render, staticRenderFns } from "./SupportTicketsDetail.vue?vue&type=template&id=21533784"
import script from "./SupportTicketsDetail.vue?vue&type=script&lang=js"
export * from "./SupportTicketsDetail.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketsDetail.vue?vue&type=style&index=0&id=21533784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports